/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDynamicLayoutAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2v9h3V9H4V4h6V2zm13 2h5v5h-2v2h4V2h-7zM2 13v9h4v-2H4v-5h4v-2zm16 2h2v5h-5v-1h-2v3h9v-9h-4zM6.6 11.25 13.543 3 12 9.75 17.4 12l-9.258 9L12 13.5z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDynamicLayoutAlt as DynamicLayoutAlt };
